import { Platform, StyleSheet } from 'react-native';
import { FontFamily } from '../../../constants/fonts';

const isIOS = Platform.OS === 'ios';

const ptExecutionSectionStyles = StyleSheet.create({
  sectionRow: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 12,
    rowGap: 12,
    alignItems: isIOS ? 'flex-start' : 'stretch',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    shadowColor: '#A8B4C5',
    shadowOpacity: 0.08,
    shadowRadius: 6,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
    paddingVertical: isIOS ? 16 : 20,
    paddingHorizontal: isIOS ? 20 : 24,
    width: isIOS ? '100%' : undefined,
    minWidth: isIOS ? 0 : undefined,
    minHeight: isIOS ? undefined : 300,
    flexBasis: isIOS ? '100%' : 0,
    flexGrow: 1,
    flexShrink: 1,
    rowGap: 4,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: isIOS ? 10 : 12,
  },
  title: {
    fontSize: 16,
    lineHeight: 20,
    color: '#1A1D21',
    fontFamily: FontFamily.bold,
    fontWeight:'700',
  },
  subTitle: {
    marginLeft: 4,
    fontSize: 12,
    lineHeight: 16,
    color: '#838383',
    fontFamily: FontFamily.regular,
    fontWeight: '400',
  },
  trendChartContainer: {
    width: '100%',
    minHeight: isIOS ? 178 : 220,
    rowGap: 6,
  },
  emptyContainer: {
    width: '100%',
    minHeight: isIOS ? 178 : 220,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyText: {
    fontSize: 16,
    color: '#3A3A3A',
    fontFamily: FontFamily.regular,
  },
  trendLegendRow: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 6,
    marginLeft: 8,
    marginTop: isIOS ? 0 : 2,
  },
  trendLegendDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#005CBC',
  },
  trendLegendText: {
    fontSize: 12,
    lineHeight: 16,
    color: '#616161',
    fontFamily: FontFamily.medium,
  },
  regionList: {
    rowGap: isIOS ? 6 : 10,
  },
  regionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: isIOS ? 8 : 12,
    marginBottom: isIOS ? 6 : 8,
  },
  regionLabel: {
    fontSize: 12,
    color: '#3A3A3A',
    fontFamily: FontFamily.medium,
    textAlign: 'right',
    flexShrink: 0,
  },
  progressTrackWrap: {
    flex: 1,
    position: 'relative',
    justifyContent: 'center',
  },
  progressTrack: {
    width: '100%',
    height: isIOS ? 22 : 26,
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: '#EAF0FB',
  },
  progressFill: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingRight: isIOS ? 8 : 10,
    // Small floor so a 0%/near-0% value still renders a visible sliver of
    // color instead of disappearing entirely — NOT large enough to make
    // low percentages (e.g. 4%–7%) look the same width as each other.
    minWidth: 3,
  },
  progressFillRed: {
    backgroundColor: '#C12C01',
  },
  progressFillBlue: {
    backgroundColor: '#005CBC',
  },
  progressText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontFamily: FontFamily.bold,
    lineHeight: 16,
  },
  // Label rendered outside/after the fill when the bar is too narrow to
  // legibly contain the white text (low percentages).
  progressOutsideLabel: {
    position: 'absolute',
    fontSize: 12,
    fontFamily: FontFamily.bold,
    lineHeight: 16,
    marginLeft: 6,
  },
  // Extra left offset for very small values (0%/1%) whose bar sliver is too
  // narrow and would otherwise sit directly under/behind the label text.
  progressOutsideLabelTight: {
    marginLeft: 14,
  },
  progressOutsideLabelRed: {
    color: '#C12C01',
  },
  progressOutsideLabelBlue: {
    color: '#005CBC',
  },
});

export default ptExecutionSectionStyles;
